import Keycloak from 'keycloak-js'

let _instance = null

export function getKeycloak() {
    return _instance
}

export const vueKeycloak = {
    install(app, { config, initOptions }) {
        const keycloak = new Keycloak(config)
        _instance = keycloak
        app.config.globalProperties.$keycloak = keycloak
        keycloak.init(initOptions).catch(err => {
            console.error('Keycloak init error:', err)
        })
    }
}
